import { render, staticRenderFns } from "./advocacy-alert-widget-app.vue?vue&type=template&id=036b4827&"
import script from "./advocacy-alert-widget-app.vue?vue&type=script&lang=js&"
export * from "./advocacy-alert-widget-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('036b4827', component.options)
    } else {
      api.reload('036b4827', component.options)
    }
    module.hot.accept("./advocacy-alert-widget-app.vue?vue&type=template&id=036b4827&", function () {
      api.rerender('036b4827', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/containers/advocacy-alert-widget-app.vue"
export default component.exports